import { markBillingAsPaidChecked } from '@/lib/billing/mark-billing-paid'
import { toast } from 'react-toastify'


import BillingInfoSection, { BillingInfoData } from './BillingInfoSection'

/**
 * Renderiza CADA cobrança complementar/parcela (filhas de uma cobrança âncora) com o
 * MESMO bloco completo da cobrança principal (`BillingInfoSection`) — comprovantes,
 * marcar como pago, PIX/boleto etc. Substitui a lista simplificada, que perdia essas
 * ações e o informativo. Marcar como pago aqui usa o endpoint genérico da própria
 * cobrança (`markBillingAsPaid`), pois cada filha é uma cobrança independente.
 *
 * O aviso "Falta X para completar o pagamento" NÃO é passado aqui de propósito — ele fica
 * único no bloco âncora (topo), para não se repetir em cada cobrança.
 */

interface BillingChildrenSectionsProps {
    adjustments?: BillingInfoData[] | null
    onReload: () => void
    canUpdate?: boolean
    /**
     * Rótulo de cada filha. Padrão "Cobrança" (telas de atendimento, onde não há
     * ambiguidade). No detalhe da cobrança, onde a âncora aparece no mesmo formato
     * logo acima, vale nomear para distinguir uma da outra.
     */
    childTitle?: string
    /** Esconde o link "Detalhes" de cada filha. */
    hideDetailsLink?: boolean
}

export default function BillingChildrenSections({
    adjustments,
    onReload,
    canUpdate = false,
    childTitle,
    hideDetailsLink = false,
}: BillingChildrenSectionsProps) {
    const items = (adjustments || []).filter(a => a.status !== 'CANCELLED')
    if (!items.length) return null

    return (
        <>
            {items.map(child => (
                <BillingInfoSection
                    key={child.id}
                    billing={child}
                    canUpdate={canUpdate}
                    title={childTitle}
                    hideDetailsLink={hideDetailsLink}
                    onBillingChanged={onReload}
                    onMarkAsPaid={async () => {
                        const response = await markBillingAsPaidChecked(child.id)
                        if (response.success) {
                            const result = response.result as any
                            if (result?.pending) {
                                toast.info(
                                    result.message ||
                                        'A solicitação de aprovação para marcar como pago foi enviada'
                                )
                            } else {
                                toast.success('Cobrança marcada como paga!')
                            }
                            onReload()
                        } else {
                            toast.error(
                                response.error || 'Erro ao marcar como paga'
                            )
                        }
                    }}
                />
            ))}
        </>
    )
}
